import { useRef, useEffect } from "react";

export default function Stars() {
  const ref = useRef(null);

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    let id;

    const set = () => {
      c.width  = c.offsetWidth;
      c.height = c.offsetHeight;
    };
    set();
    window.addEventListener("resize", set);

    const pts = Array.from({ length: 180 }, () => ({
      x:  Math.random() * 2000,
      y:  Math.random() * 1200,
      r:  Math.random() * 1.3 + 0.2,
      p:  Math.random() * Math.PI * 2,
      sp: Math.random() * 0.005 + 0.002,
    }));

    function draw() {
      ctx.clearRect(0, 0, c.width, c.height);
      pts.forEach((s) => {
        s.p += s.sp;
        const a = 0.2 + Math.sin(s.p) * 0.3;
        ctx.beginPath();
        ctx.arc(s.x % c.width, s.y % c.height, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(180,210,255,${a})`;
        ctx.fill();
      });
      id = requestAnimationFrame(draw);
    }
    draw();

    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener("resize", set);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      style={{
        position:      "absolute",
        inset:         0,
        width:         "100%",
        height:        "100%",
        pointerEvents: "none",
      }}
    />
  );
}
